import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import ContractForm from "./pages/ContractForm";
import ContractDetail from "./pages/ContractDetail";
import OwnersList from "./pages/OwnersList";
import OwnerDetail from "./pages/OwnerDetail";
import SetPassword from "./pages/SetPassword";
import Cobranza from "./pages/Cobranza";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Usuarios from "./pages/Usuarios";
import MiPerfil from "./pages/MiPerfil";
import Egresos from "./pages/Egresos";
import CajasChicas from "./pages/CajasChicas";
import NuevoGasto from "./pages/NuevoGasto";
import GastosRecurrentes from "./pages/GastosRecurrentes";
import VerGasto from "./pages/VerGasto";
import EditarGasto from "./pages/EditarGasto";
import MisGastos from "./pages/MisGastos";
import Reportes from "./pages/Reportes";
import Documentos from "./pages/Documentos";
import Renovaciones from "./pages/Renovaciones";
import RenovacionDetail from "./pages/RenovacionDetail";
import Propiedades from "./pages/Propiedades";
import PropiedadDetail from "./pages/PropiedadDetail";
import PropiedadWizard from "./pages/PropiedadWizard";
import Caratulas from "./pages/Caratulas";
import Inicio from "./pages/Inicio";
import MaestroCSV from "./pages/MaestroCSV";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              user ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />
            }
          />
          <Route
            path="/establecer-contrasena"
            element={<SetPassword onLogin={handleLogin} />}
          />
          <Route
            path="/forgot-password"
            element={
              user ? <Navigate to="/dashboard" /> : <ForgotPassword />
            }
          />
          <Route
            path="/reset-password"
            element={
              user ? <Navigate to="/dashboard" /> : <ResetPassword />
            }
          />
          <Route
            path="/"
            element={<LandingPage />}
          />
          <Route
            path="/dashboard"
            element={
              user ? (
                user.rol === "propietario" ? (
                  <Dashboard user={user} onLogout={handleLogout} />
                ) : (
                  <Inicio user={user} onLogout={handleLogout} />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/contratos"
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/contratos/nuevo"
            element={
              user ? (
                <ContractForm user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/contratos/editar/:id"
            element={
              user ? (
                <ContractForm user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/contratos/:id"
            element={
              user ? (
                <ContractDetail user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/propietarios"
            element={
              user ? (
                <OwnersList user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/propietarios/:email"
            element={
              user ? (
                <OwnerDetail user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/propiedades"
            element={
              user ? (
                <Propiedades user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/caratulas"
            element={
              user ? (
                <Caratulas user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/propiedades/nueva"
            element={
              user ? (
                <PropiedadWizard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/propiedades/:id"
            element={
              user ? (
                <PropiedadDetail user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/cobranza"
            element={
              user ? (
                <Cobranza user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/usuarios"
            element={
              user && user.rol === "maestro" ? (
                <Usuarios user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/base-maestra"
            element={
              user && user.rol === "maestro" ? (
                <MaestroCSV user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/perfil"
            element={
              user ? (
                <MiPerfil user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/egresos"
            element={
              user ? (
                <Egresos user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/egresos/nuevo"
            element={
              user ? (
                <NuevoGasto user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/egresos/recurrentes"
            element={
              user ? (
                <GastosRecurrentes user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/egresos/:id"
            element={
              user ? (
                <VerGasto user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/egresos/:id/editar"
            element={
              user ? (
                <EditarGasto user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/mis-gastos"
            element={
              user ? (
                <MisGastos user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/cajas-chicas"
            element={
              user ? (
                <CajasChicas user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reportes"
            element={
              user ? (
                <Reportes user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/documentos"
            element={
              user ? (
                <Documentos user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/renovaciones"
            element={
              user ? (
                <Renovaciones user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/renovaciones/:id"
            element={
              user ? (
                <RenovacionDetail user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
